var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewShadeMount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "144px",
    height: "168px",
    viewBox: "0 0 384.9 448.5",
    enableBackground: "new 0 0 384.9 448.5",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 9.3,
    y: 7.5,
    fill: "#464545",
    width: 8.9,
    height: 2.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M356.4,10.4h-9.9V7.5h9.9V10.4z M336.5,10.4h-9.9V7.5h9.9V10.4z M316.6,10.4h-9.9V7.5h9.9V10.4z  M296.7,10.4h-9.9V7.5h9.9V10.4z M276.8,10.4h-9.9V7.5h9.9V10.4z M256.9,10.4H247V7.5h9.9V10.4z M237,10.4h-9.9V7.5h9.9V10.4z  M217.2,10.4h-9.9V7.5h9.9V10.4z M197.3,10.4h-9.9V7.5h9.9V10.4z M177.4,10.4h-9.9V7.5h9.9V10.4z M157.5,10.4h-9.9V7.5h9.9V10.4z  M137.6,10.4h-9.9V7.5h9.9V10.4z M117.7,10.4h-9.9V7.5h9.9V10.4z M97.8,10.4h-9.9V7.5h9.9V10.4z M77.9,10.4H68V7.5h9.9V10.4z  M58,10.4h-9.9V7.5H58V10.4z M38.1,10.4h-9.9V7.5h9.9V10.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.4,
    y: 7.5,
    fill: "#464545",
    width: 8.9,
    height: 2.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2,
    x1: 33,
    y1: 40.4,
    x2: 33,
    y2: 18.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "38.9,38.6 33,49 27,38.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "38.9,20.2 33,9.9 27,20.2  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2,
    x1: 352.1,
    y1: 40.4,
    x2: 352.1,
    y2: 18.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "358.1,38.6 352.1,49 346.2,38.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "358.1,20.2 352.1,9.9 346.2,20.2  "
  })))), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 375.6,
    y1: 49.9,
    x2: 333.1,
    y2: 49.9
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 53,
    y1: 49.9,
    x2: 10.6,
    y2: 49.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 49.9,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 280.2,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 73,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 234,
    height: 342.8
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewShadeMount);
export default __webpack_public_path__ + "static/media/new_shade_mount.297f9541d24acd1f0100be07857a5fdd.svg";
export { ForwardRef as ReactComponent };